<div class="mega-menu-container">
  <div class="mega-menu-content">
    <div nz-row nzType="flex" class="mega-menu-title">
      <div>
        <div nz-row>
          <div class="title-col sector-title">
            <span>Sectors</span>
          </div>
          <div class="title-col industry-title">
            <span>Industries</span>
          </div>
        </div>
      </div>
      <div class="title-col company-title">
        <span>Companies</span>
      </div>
    </div>

    <div nz-row nzType="flex">
      <div (mouseleave)="resetSectorSelection()">
        <div nz-row>
          <div class="sectors-container">
            <div *ngFor="let sector of sectors" class="mega-menu-primary-item">
              <div
                class="mega-menu-item-content"
                [ngClass]="{
                  'is-active': activeSector === sector.sectorId,
                  'is-selected': selectedSector === sector.sectorId
                }"
                (mouseover)="onSectorHover(sector)"
              >
                <span>
                  {{ sector.sectorName }}
                </span>
                <span class="mega-menu-item-arrow">
                  <va-icon
                    isFontAwesome="true"
                    [name]="faChevronRight"
                  ></va-icon>
                </span>
              </div>
            </div>
          </div>
          <div class="industries-container">
            <ng-container
              *ngFor="let item of sectorToIndustries[activeSector]; index as j"
            >
              <div class="mega-menu-secondary-item">
                <div
                  class="mega-menu-item-content"
                  [title]="item.industryName"
                  [ngClass]="{
                    'is-selected selected-industry':
                      selectedIndustry === item.industryId
                  }"
                  (click)="onIndustrySelect(item.industryId)"
                >
                  <!-- [nzTooltipTitle]="item.industryName"
                    nzTooltipPlacement="top"
                    nz-tooltip -->
                  <span
                    class="industry-sub-title"
                    style="text-decoration: none"
                  >
                    <span>{{ item.industryName }}</span>
                  </span>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <ng-container *ngIf="!error">
        <div class="cluster-container mega-menu-secondary-item">
          <app-cluster-filter
            [isMegaMenuReady]="isMegaMenuReady"
            [clusters]="clusters"
            [selectedCluster]="selectedCluster"
            (clusterChange)="onClusterChange($event)"
          ></app-cluster-filter>
        </div>
        <div
          class="industries-container geography-container mega-menu-secondary-item"
        >
          <app-industry-geography-filter
            [isMegaMenuReady]="isMegaMenuReady"
            [allGeography]="allGeography"
            [popularGeography]="popularGeography"
            [otherGeographies]="otherGeographies"
            [popularSelected]="popularSelected"
            [otherSelected]="otherSelected"
            (geographySelect)="onOtherValueChange($event)"
          ></app-industry-geography-filter>
        </div>
        <div
          class="industries-container market-cap-container mega-menu-secondary-item"
        >
          <app-industry-market-cap-filter
            [isMegaMenuReady]="isMegaMenuReady"
            [marketCaps]="marketCaps"
            [selectedMarketCaps]="selectedMarketCaps"
            [marketCapExpandedKeys]="marketCapExpandedKeys"
            (marketCapSelect)="onMarketCapChange($event)"
          ></app-industry-market-cap-filter>
        </div>
      </ng-container>
      <ng-container *ngIf="error">
        <div nz-col nzSpan="16" class="error-div">
          <div class="error-msg">
            <va-icon
              isFontAwesome="true"
              [name]="faExclamationTriangle"
              class="info-icon"
            ></va-icon>
            <span class="error-text">No data available.</span>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div class="buttons-container">
    <span class="company-text"
      >{{ selectedCompanyCount }} Companies Selected</span
    >
    <va-button
      btnType="outline"
      size="medium"
      (click)="closeMegaMenu()"
      class="button ant-btn-primary-hollow"
    >
      Cancel
    </va-button>
    <va-button
      btnType="solid"
      size="medium"
      class="menu-apply-btn"
      [isDisabled]="error || disableApply || selectedCompanyCount === 0"
      (click)="apply()"
    >
      Apply
    </va-button>
  </div>
</div>
